import { axios } from '@/utils/request'

// 延保管理 - 预加载
export function getMaintainPre(parameter) {
  return axios({
    url: '/merchant.php/maintain/pre',
    method: 'get',
    params: parameter
  })
}

// 延保管理 - 延保列表
export function getMaintainList(parameter) {
  return axios({
    url: '/merchant.php/maintain/getList',
    method: 'get',
    params: parameter
  })
}

// 延保管理 -  保存延保设置
export function postMaintainSetting(data) {
  return axios({
    url: '/merchant.php/maintain/saveSetting',
    method: 'post',
    data: data
  })
}

// 基础 - 检查服务
export function checkService(parameter) {
  return axios({
    url: '/merchant.php/Base/checkService',
    method: 'get',
    params: parameter
  })
}

export function updateList() {
  return axios({
    url: '/merchant.php/maintain/updateList',
    method: 'get',
    params: ''
  })
}
